import { BASE_URL } from "@/utils/api";

export const useLogin = () => {
  const startLogin = () => {
    const url = `${BASE_URL}/auth/oauth/start`;
    window.location.href = url;
  };

  return { startLogin };
};
